import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import moment from "bootstrap/bootstrap-durationpicker";

"use strict";
ko.bindingHandlers.durationpicker = {
    init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        $(element).durationpicker({
            icons: { up: "fa fa-caret-up", down: "fa fa-caret-down" },
            defaultTime: ko.unwrap(valueAccessor())
        });
        var observable = valueAccessor();
        var value = ko.unwrap(observable), 
            c = $(element).data("__changing");
        var dp = $(element).data("durationpicker");
        ko.utils.registerEventHandler(element, "change", function() {
            if ($(element).data("__changing"))
                return;

            var val = dp.getDuration();
            if (val && typeof val === "string")  {
                var tmp = val.split(":");
                val = 60 * (tmp[0] || 0)  +  1 * (tmp[1] || 0)  + (tmp[2] || 0) / 60;
            }
            $(element).data("__changing", true);
            try {
                console.log("setting observable to: ", val);
                observable(val);
            }
            finally {
                $(element).data("__changing", false);
            }
        });
        ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
            $(element).durationpicker("destroy");
        });
    },
    update: function(element, va, allBindingsAccessor, viewModel, bindingContext) {
        var newvalue = ko.unwrap(va());
        var dp = $(element).data("durationpicker");
        if ($(element).data("__changing"))
            return;
        $(element).data("__changing", true);
        try {
            dp.setDuration(newvalue * 60);
        }
        finally {
            $(element).data("__changing", false);
        }
    }
};
